import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CalendarEvent,CalendarMonthViewDay,CalendarView, CalendarWeekViewBeforeRenderEvent} from 'angular-calendar';
import { WeekViewTimeEvent } from 'calendar-utils';
import { LanguageService } from 'src/app/service/language-service/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import esLocale from 'date-fns/locale/es';
import enUSLocale from 'date-fns/locale/en-US';
import { addDays, addMonths, differenceInMinutes, format, isSameDay, set, startOfDay, startOfHour, startOfWeek, subDays, subMonths } from 'date-fns';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CourseDetailsModalComponent } from '../courses-components/course-details-modal/course-details-modal.component';
import { ChecklistDetailsComponent } from '../calendar-events/checklist-details/checklist-details.component';
 import { WeekDay } from 'calendar-utils';
import { CalendarService } from 'src/app/service/calendar-service/calendar.service';
import { ApiService } from '../../api.service';
import { RewardsService } from 'src/app/service/rewards/rewards.service';
import { UsuarioServiceProvider } from 'src/app/service/index.providers';
import { AppPlatformService } from 'src/app/service/platform/app-platform.service';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
interface CustomCalendarEvent extends CalendarEvent {
  custom?: {
    eventName?: string;
  };
}

@Component({
  selector: 'app-complete-calendar',
  templateUrl: './complete-calendar.component.html',
  styleUrls: ['./complete-calendar.component.scss'],
})
export class CompleteCalendarComponent  implements  AfterViewInit, OnChanges, OnDestroy, OnInit {
  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLElement>;
  @Input() currentDateDisplayed: Date = new Date();
  @Input() events: CustomCalendarEvent[] = [];
  @Input() isLoadingEvents: boolean = false;
  @Output() viewDateChange = new EventEmitter<Date>();
  // excludeDays: number[] = [0, 6];
  currentLocale: string = "es";
  language:string = "es";

  private destroy$ = new Subject<void>();
  private localeMap = {
    es: esLocale,
    en: enUSLocale
  };

  private diasExpandidos: Set<string> = new Set();


  view: CalendarView = CalendarView.Week; // month, week, day
  // grupoActual: number = 0;
  // diasPorGrupo: number = 3;
  // gruposDias: Date[][] = [];
  // diasVisibles: Date[] = [];
  // horas: number[] = Array.from({ length: 24 }, (_, i) => i);

  diasPorGrupo: number = 3;
  fechaInicioGrupo: Date = new Date(); // Fecha inicial del grupo visible
  diasVisibles: Date[] = [];
  horas: number[] = Array.from({ length: 24 }, (_, i) => i);

  currentStartDay: Date = new Date();
  isMobile: boolean = false;
  calendarTypeSub:Subscription;

  // Swipe gesture tracking
  private touchStartX: number = 0;
  private touchStartY: number = 0;
  private readonly SWIPE_THRESHOLD = 50;
  private readonly SWIPE_MAX_VERTICAL = 100;

  allDayEventsExpanded: boolean = false;
  showAllDayToggle: boolean = false;
  hideAllDayLabel: boolean = false;

  rewardSub: Subscription;
  coinCustomImage: string = '';
  rewardsIsActive: boolean = false;
  baseImgUrl: string = '';
  isIos = false;

  constructor(
    private languageService: LanguageService,
    private translate: TranslateService,
    public router: Router,
    public modalCtrl: ModalController,
    public calendarService: CalendarService,
    private rewardsService: RewardsService,
    private api: ApiService,
    public up: UsuarioServiceProvider,
    private appPlatformService:AppPlatformService,
    private iab: InAppBrowser,
  ) { }


  @HostListener('window:resize')
  onResize() {
    this.detectarDispositivo();
  }

  get stickyTopValue(): string {
    return this.view === CalendarView.Week ? '70px' : '0px';
  }

  toggleAllDayEvents(): void {
    this.allDayEventsExpanded = !this.allDayEventsExpanded;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['events'] || changes['currentDateDisplayed']) {
      this.scheduleAllDayVisibilityCheck();
    }
  }

  private scheduleAllDayVisibilityCheck(): void {
    setTimeout(() => this.recalcAllDayVisibility(), 200);
  }

  private recalcAllDayVisibility(): void {
    const container = this.scrollContainer?.nativeElement?.querySelector('.cal-all-day-events');
    if (!container) {
      this.showAllDayToggle = false;
      this.hideAllDayLabel = false;
      return;
    }
    const naturalHeight = container.scrollHeight;
    this.showAllDayToggle = naturalHeight > 80;
    this.hideAllDayLabel = naturalHeight > 80;
  }

  ngOnInit() {
    this.subLanguageConfig();
    this.detectarDispositivo();
    this.initializeCalendarType();
    // this.generarGruposDias();
    this.inicializarFechaInicio();
    this.actualizarDiasVisibles();
    this.baseImgUrl = this.up.getBucketBaseUrl;
    this.isIos = this.appPlatformService.isIosHibridApp();

  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.scrollToCurrentView();
    this.recalcAllDayVisibility();
    }, 100);
  }

  private scrollToCurrentView() {
    if (this.view === CalendarView.Week || this.view === CalendarView.Day) {
      const minutesSinceStartOfDay = differenceInMinutes(startOfHour(new Date()), startOfDay(new Date()));

      // Week header (sticky day names) is 74px tall; Day view has no header
      const dayHeaderHeight = this.view === CalendarView.Week ? 74 : 0;

      // The all-day events row is also sticky and grows dynamically.
      // .all-day-events-height-reference lives in the same row so its offsetHeight
      // always matches the actual rendered height of that section.
      const allDayRef = this.scrollContainer?.nativeElement?.querySelector('.all-day-events-height-reference');
      const allDayHeight = (allDayRef ? (allDayRef as HTMLElement).offsetHeight : 0) - (this.view === CalendarView.Week ? 145 : 75);

      const headerHeight = dayHeaderHeight + allDayHeight;
      // console.log("***********scrollToCurrentView::",headerHeight,allDayHeight, allDayRef)

      this.scrollContainer.nativeElement.scrollTo({
        top: minutesSinceStartOfDay + headerHeight,
        behavior: 'smooth'
      });
    }
  }

  initializeCalendar() {
    // No-op: daysInWeek=3 on the mobile view handles everything
    // currentDateDisplayed is already set to today
  }

  initializeCalendarType() {
    this.calendarTypeSub = this.calendarService.calendarType$.subscribe(type => {
      this.view = type;
      this.allDayEventsExpanded = false;
      // Wait for Angular to re-render the new view before measuring DOM heights
      setTimeout(() => {
        this.scrollToCurrentView();
        this.recalcAllDayVisibility();
      }, 100);
    });
  }


  // Navegar 3 días hacia atrás
  previousThreeDays() {
    this.currentDateDisplayed = subDays(this.currentDateDisplayed, 3);
    this.viewDateChange.emit(this.currentDateDisplayed);
  }

  // Navegar 3 días hacia adelante
  nextThreeDays() {
    this.currentDateDisplayed = addDays(this.currentDateDisplayed, 3);
    this.viewDateChange.emit(this.currentDateDisplayed);
  }

  // Volver al día actual
  goToToday() {
    this.currentDateDisplayed = new Date();
    this.viewDateChange.emit(this.currentDateDisplayed);
  }

  // Obtener el rango de fechas visibles (útil para mostrar en el header)
  getVisibleDateRange(): string {
    if (!this.isMobile) {
      // Lógica para desktop: primera y última fecha de la semana
      const startOfWeek = new Date(this.currentDateDisplayed);
      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(endOfWeek.getDate() + 6);

      return `${this.formatDate(startOfWeek)} - ${this.formatDate(endOfWeek)}`;
    } else {
      // Lógica para mobile: 3 días consecutivos
      const day1 = new Date(this.currentStartDay);
      const day3 = new Date(this.currentStartDay);
      day3.setDate(day3.getDate() + 2);

      return `${this.formatDate(day1)} - ${this.formatDate(day3)}`;
    }
  }

  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short'
    };
    return date.toLocaleDateString(this.currentLocale, options);
  }


  // generarGruposDias() {
  //   const inicioSemana = startOfWeek(this.currentDateDisplayed, { weekStartsOn: 0 }); // Domingo
  //   this.gruposDias = [];

  //   // Dividir la semana en grupos de 3 días
  //   for (let i = 0; i < 7; i += this.diasPorGrupo) {
  //     const grupo: Date[] = [];
  //     for (let j = 0; j < this.diasPorGrupo && (i + j) < 7; j++) {
  //       grupo.push(addDays(inicioSemana, i + j));
  //     }
  //     this.gruposDias.push(grupo);
  //   }
  // }

  // actualizarDiasVisibles() {
  //   this.diasVisibles = this.gruposDias[this.grupoActual] || [];
  // }

  // anteriorGrupo() {
  //   if (this.grupoActual > 0) {
  //     this.grupoActual--;
  //     this.actualizarDiasVisibles();
  //   }
  // }

  // siguienteGrupo() {
  //   if (this.grupoActual < this.gruposDias.length - 1) {
  //     this.grupoActual++;
  //     this.actualizarDiasVisibles();
  //   }
  // }

// }
  // obtenerRangoFechas(): string {
  //   if (this.diasVisibles.length === 0) return '';

  //   const primerDia = this.diasVisibles[0];
  //   const ultimoDia = this.diasVisibles[this.diasVisibles.length - 1];
  //   const locale = this.localeMap[this.currentLocale];

  //   return `${format(primerDia, 'd MMM', { locale })} - ${format(ultimoDia, 'd MMM', { locale })}`;
  // }

  // esHoy(fecha: Date): boolean {
  //   const hoy = new Date();
  //   return fecha.getDate() === hoy.getDate() &&
  //          fecha.getMonth() === hoy.getMonth() &&
  //          fecha.getFullYear() === hoy.getFullYear();
  // }

  // obtenerEventosAllDay(fecha: Date): CalendarEvent[] {
  //   return this.events.filter(evento =>
  //     evento.allDay &&
  //     fecha >= new Date(evento.start.setHours(0, 0, 0, 0)) &&
  //     fecha <= new Date(evento.end.setHours(23, 59, 59, 999))
  //   );
  // }f

  // obtenerEventosEnHora(fecha: Date, hora: number): CalendarEvent[] {
  //   return this.events.filter(evento => {
  //     if (evento.allDay) return false;

  //     const eventoFecha = new Date(evento.start);
  //     const esElMismoDia = eventoFecha.getDate() === fecha.getDate() &&
  //                          eventoFecha.getMonth() === fecha.getMonth() &&
  //                          eventoFecha.getFullYear() === fecha.getFullYear();

  //     return esElMismoDia && eventoFecha.getHours() === hora;
  //   });
  // }

  // formatearHorario(start: Date, end: Date): string {
  //   return `${format(start, 'HH:mm')} - ${format(end, 'HH:mm')}`;
  // }



  // nuevoooo
  inicializarFechaInicio() {
    // Iniciar desde hoy, pero ajustado para mostrar grupos de 3
    const hoy = startOfDay(new Date());
    const diaDeLaSemana = hoy.getDay(); // 0 = Domingo, 1 = Lunes, etc.

    // Calcular cuántos días retroceder para llegar al inicio del grupo que contiene hoy
    const diasDesdeInicioGrupo = diaDeLaSemana % this.diasPorGrupo;
    this.fechaInicioGrupo = subDays(hoy, diasDesdeInicioGrupo);
  }

  actualizarDiasVisibles() {
    this.diasVisibles = [];
    for (let i = 0; i < this.diasPorGrupo; i++) {
      this.diasVisibles.push(addDays(this.fechaInicioGrupo, i));
    }
  }

  anteriorGrupo() {
    // Retroceder 3 días
    this.fechaInicioGrupo = subDays(this.fechaInicioGrupo, this.diasPorGrupo);
    this.actualizarDiasVisibles();
  }

  siguienteGrupo() {
    // Avanzar 3 días
    this.fechaInicioGrupo = addDays(this.fechaInicioGrupo, this.diasPorGrupo);
    this.actualizarDiasVisibles();
  }

  irAHoy() {
    this.inicializarFechaInicio();
    this.actualizarDiasVisibles();
  }

  obtenerRangoFechas(): string {
    if (this.diasVisibles.length === 0) return '';

    const primerDia = this.diasVisibles[0];
    const ultimoDia = this.diasVisibles[this.diasVisibles.length - 1];
    const locale = this.localeMap[this.currentLocale];

    // Mostrar mes y año si cambian
    if (primerDia.getMonth() === ultimoDia.getMonth()) {
      return `${format(primerDia, 'd', { locale })} - ${format(ultimoDia, 'd MMM yyyy', { locale })}`;
    } else {
      return `${format(primerDia, 'd MMM', { locale })} - ${format(ultimoDia, 'd MMM yyyy', { locale })}`;
    }
  }


  esHoy(fecha: Date): boolean {
    const hoy = startOfDay(new Date());
    return startOfDay(fecha).getTime() === hoy.getTime();
  }

  obtenerEventosAllDay(fecha: Date): CalendarEvent[] {
  return this.events.filter(evento => {
    if (!evento.allDay) return false;

    // Convertir a fecha local sin horas
    const fechaBuscada = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
    const eventoStart = new Date(evento.start.getFullYear(), evento.start.getMonth(), evento.start.getDate());
    const eventoEnd = new Date(evento.end.getFullYear(), evento.end.getMonth(), evento.end.getDate());

    // Verificar si la fecha está dentro del rango del evento
    return fechaBuscada >= eventoStart && fechaBuscada <= eventoEnd;
  });
}

  // obtenerEventosAllDay(fecha: Date): CalendarEvent[] {
  //   const fechaStart = startOfDay(fecha);
  //   const fechaEnd = startOfDay(addDays(fecha, 1));

  //   return this.events.filter(evento => {
  //     if (!evento.allDay) return false;

  //     const eventoStart = startOfDay(evento.start);
  //     const eventoEnd = startOfDay(evento.end);

  //     return fechaStart <= eventoEnd && fechaEnd > eventoStart;
  //   });
  // }

  // obtenerEventosEnHora(fecha: Date, hora: number): CalendarEvent[] {
  //   return this.events.filter(evento => {
  //     if (evento.allDay) return false;

  //     const eventoFecha = new Date(evento.start);
  //     const esElMismoDia = startOfDay(eventoFecha).getTime() === startOfDay(fecha).getTime();

  //     return esElMismoDia && eventoFecha.getHours() === hora;
  //   });
  // }

obtenerEventosEnHora(fecha: Date, hora: number): CalendarEvent[] {
  // console.log('Buscando eventos para:', fecha, 'hora:', hora);

  return this.events.filter(evento => {
    // Ignorar eventos all-day
    if (evento.allDay) return false;


    // Convertir fechas a hora local
    const eventoStart = new Date(evento.start);
    const eventoEnd = new Date(evento.end);

    // Verificar que el evento es del mismo día (en hora local)
    const fechaLocal = new Date(fecha);
    const esElMismoDia =
      eventoStart.getFullYear() === fechaLocal.getFullYear() &&
      eventoStart.getMonth() === fechaLocal.getMonth() &&
      eventoStart.getDate() === fechaLocal.getDate();

    if (!esElMismoDia) return false;

    // Obtener horas en hora local (esto convierte automáticamente UTC a tu zona horaria)
    const horaInicio = eventoStart.getHours();
    const minutosInicio = eventoStart.getMinutes();
    const horaFin = eventoEnd.getHours();
    const minutosFin = eventoEnd.getMinutes();

    // Convertir a minutos totales desde medianoche
    const eventoInicioEnMinutos = horaInicio * 60 + minutosInicio;
    const eventoFinEnMinutos = horaFin * 60 + minutosFin;
    const horaActualEnMinutos = hora * 60;
    const horaSiguienteEnMinutos = (hora + 1) * 60;

    // El evento se muestra si está activo durante algún momento de esta hora
    return eventoInicioEnMinutos < horaSiguienteEnMinutos &&
           eventoFinEnMinutos > horaActualEnMinutos;
  });
}

  formatearHorario(start: Date, end: Date): string {
    return `${format(start, 'HH:mm')} - ${format(end, 'HH:mm')}`;
  }



  subLanguageConfig() {
    this.languageService.getCurrentLang().pipe(takeUntil(this.destroy$))
    .subscribe((lang) => {
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
      this.language = lang;
      this.currentLocale = lang
      console.log("------------------------",this.language )
    });
  }

  onViewDateChange(date: Date) {
    this.viewDateChange.emit(date);
  }

  obtenerNombreDia(fecha: Date): string {
    const locale = this.localeMap[this.currentLocale];
    return format(fecha, 'EEE', { locale });
  }

  obtenerNombreDiaCompleto(fecha: Date): string {
    const locale = this.localeMap[this.currentLocale];
    return format(fecha, 'EEEE', { locale });
  }

  obtenerNombreDiaCorto(fecha: Date): string {
    const locale = this.localeMap[this.currentLocale];
    const short = format(fecha, 'EEEEE', { locale });
    // EEEEE returns single letter; for better readability use first 3 chars of EEE
    return format(fecha, 'EEE', { locale }).substring(0, 3).toUpperCase();
  }

  obtenerNombreMes(fecha: Date): string {
    const locale = this.localeMap[this.currentLocale];
    return format(fecha, 'MMM', { locale });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.calendarTypeSub?.unsubscribe();
    this.rewardSub?.unsubscribe();
  }

  // test agrupar allday events

   obtenerEventosDelDia(fecha: Date): CalendarEvent[] {
    console.log("obtenerEventosDelDia::", this.events.filter(evento =>
      evento.allDay &&
      isSameDay(evento.start, fecha)
    ))
    return this.events.filter(evento =>
      evento.allDay &&
      isSameDay(evento.start, fecha)
    );
  }

   estaExpandido(fecha: Date): boolean {
    const key = this.obtenerKeyFecha(fecha);
    return this.diasExpandidos.has(key);
  }

  expandirEventos(fecha: Date): void {
    const key = this.obtenerKeyFecha(fecha);
    this.diasExpandidos.add(key);
  }

  colapsarEventos(fecha: Date): void {
    const key = this.obtenerKeyFecha(fecha);
    this.diasExpandidos.delete(key);
  }

  private obtenerKeyFecha(fecha: Date): string {
    return `${fecha.getFullYear()}-${fecha.getMonth()}-${fecha.getDate()}`;
  }

  getSortedEventsForMonth(events: CalendarEvent[], limit: number = 3): CalendarEvent[] {
    const sorted = [...events].sort((a, b) => {
      if (a.allDay && !b.allDay) return -1;
      if (!a.allDay && b.allDay) return 1;
      return a.start.getTime() - b.start.getTime();
    });
    return sorted.slice(0, limit);
  }

  verMasEventos(day: CalendarMonthViewDay) {
    this.currentDateDisplayed = day.date;
    this.view = CalendarView.Day;
    this.calendarService.setCalendarType(CalendarView.Day);
    this.viewDateChange.emit(this.currentDateDisplayed);
  }

  detectarDispositivo() {
    this.isMobile = window.innerWidth < 1024;
  }

  // Swipe gesture handlers
  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].clientX;
    this.touchStartY = event.changedTouches[0].clientY;
  }

  onTouchEnd(event: TouchEvent) {
    const touchEndX = event.changedTouches[0].clientX;
    const touchEndY = event.changedTouches[0].clientY;
    const deltaX = touchEndX - this.touchStartX;
    const deltaY = Math.abs(touchEndY - this.touchStartY);

    // Only trigger if horizontal swipe exceeds threshold and vertical movement is small
    if (Math.abs(deltaX) > this.SWIPE_THRESHOLD && deltaY < this.SWIPE_MAX_VERTICAL) {
      if (deltaX > 0) {
        // Swipe right -> go to previous 3 days
        this.previousThreeDays();
      } else {
        // Swipe left -> go to next 3 days
        this.nextThreeDays();
      }
    }
  }

  onDayHeaderClick(day: WeekDay) {
    // Optional: handle day header click
  }

  /**
   * Reposiciona eventos solapados en la vista week para crear efecto cascada (overlap).
   * Cada evento subsiguiente se desplaza un porcentaje a la derecha y se superpone sobre el anterior.
   */
  onBeforeWeekViewRender(renderEvent: CalendarWeekViewBeforeRenderEvent): void {
    console.log("Before week view render:", renderEvent);
    if (!renderEvent?.hourColumns) return;

    renderEvent.hourColumns.forEach((column) => {
      const events = column.events;
      if (!events || events.length <= 1) return;

      const groups = this.findTimeEventOverlapGroups(events);

      groups.forEach(group => {
        if (group.length <= 1) return;

        // Ordenar por posición left original (orden de columna de la librería), luego por top
        group.sort((a, b) => a.left - b.left || a.top - b.top);

        const OVERLAP_OFFSET = 20; // porcentaje de desplazamiento por evento
        const MAX_TOTAL_OFFSET = 80; // máximo desplazamiento total para que el último evento sea visible
        const offset = Math.min(OVERLAP_OFFSET, MAX_TOTAL_OFFSET / (group.length - 1));

        group.forEach((event, index) => {
          const newLeft = index * offset;
          event.left = newLeft;
          event.width = 100 - newLeft;
        });
      });
    });
  }

  private findTimeEventOverlapGroups(events: WeekViewTimeEvent[]): WeekViewTimeEvent[][] {
    const groups: WeekViewTimeEvent[][] = [];
    const visited = new Set<number>();

    for (let i = 0; i < events.length; i++) {
      if (visited.has(i)) continue;

      const group = [events[i]];
      visited.add(i);

      let changed = true;
      while (changed) {
        changed = false;
        for (let j = 0; j < events.length; j++) {
          if (visited.has(j)) continue;

          const overlaps = group.some(ge => {
            const aTop = ge.top;
            const aBottom = ge.top + ge.height;
            const bTop = events[j].top;
            const bBottom = events[j].top + events[j].height;
            return aTop < bBottom && bTop < aBottom;
          });

          if (overlaps) {
            group.push(events[j]);
            visited.add(j);
            changed = true;
          }
        }
      }

      groups.push(group);
    }

    return groups;
  }

  // Swipe gesture handlers for day and month views
  onDayMonthTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].clientX;
    this.touchStartY = event.changedTouches[0].clientY;
  }

  onDayMonthTouchEnd(event: TouchEvent) {
    const touchEndX = event.changedTouches[0].clientX;
    const touchEndY = event.changedTouches[0].clientY;
    const deltaX = touchEndX - this.touchStartX;
    const deltaY = Math.abs(touchEndY - this.touchStartY);

    if (Math.abs(deltaX) > this.SWIPE_THRESHOLD && deltaY < this.SWIPE_MAX_VERTICAL) {
      if (this.view === CalendarView.Day) {
        this.currentDateDisplayed = deltaX > 0
          ? subDays(this.currentDateDisplayed, 1)
          : addDays(this.currentDateDisplayed, 1);
      } else if (this.view === CalendarView.Month) {
        this.currentDateDisplayed = deltaX > 0
          ? subMonths(this.currentDateDisplayed, 1)
          : addMonths(this.currentDateDisplayed, 1);
      }
      this.viewDateChange.emit(this.currentDateDisplayed);
    }
  }





}
